import { BaselineEpochPanel } from './baseline-epoch-panel'
import { SeedKnowledgeMapPanel } from './seed-knowledge-map-panel'

/**
 * Setup tab — onboarding / initial client configuration. Seed the knowledge
 * map once during onboarding. Placed last in the tab bar so day-to-day coaching
 * flows stay left; revisit mainly at client start-up.
 */
export function SetupView() {
  return (
    <div className="space-y-6">
      <p className="text-muted-foreground text-xs">
        Initial client setup — seed the knowledge map when onboarding, then
        adjust plan inputs as needed. Most coaches rarely revisit this tab after
        the first few weeks.
      </p>

      <BaselineEpochPanel />
      <SeedKnowledgeMapPanel />
    </div>
  )
}
